<template lang="html">
  <img
    class="brand-logo"
    src="@/assets/logo.svg"
    alt="Omroep West"
    width="260"
  />
  <h1 class="title">Heb je de Omroep West app al?</h1>
  <div class="d-grid gap-2">
    <button
      type="button"
      class="btn btn-lg rounded-0"
      :class="[
        checkedAnswer === 'Ja'
          ? 'btn-secondary text-light'
          : 'btn-outline-secondary',
      ]"
      @click="setQuestionOne('Ja')"
    >
      Ja
    </button>
    <button
      type="button"
      class="btn btn-lg rounded-0"
      :class="[
        checkedAnswer === 'Nee'
          ? 'btn-secondary text-light'
          : 'btn-outline-secondary',
      ]"
      @click="setQuestionOne('Nee')"
    >
      Nee
    </button>
  </div>
</template>

<script>
export default {
  name: "QuestionOneScreen",
  data: () => ({
    checkedAnswer: null,
  }),
  methods: {
    setQuestionOne(answer) {
      this.checkedAnswer = answer;
      this.$store.commit("setQuestionOne", answer);
      this.$store.commit("setQuestionThree", null);
      this.$store.commit("setQuestionFour", null);
      this.$store.commit("setQuestionGdpr", null);
      this.$store.commit("setSavedData", null);
      if (answer === "Ja") {
        this.$store.commit("setQuestionTwo", "");
      } else {
        this.$store.commit("setQuestionTwo", null);
      }
    },
  },
};
</script>

<style lang="css" scoped>
h1 {
  font-size: 1.6rem;
  color: #ffffff;
  margin-bottom: 24px;
  font-weight: 700;
}
.brand-logo {
  margin-bottom: 20px;
}
.btn {
  min-height: 56px;
  font-size: 1rem;
  font-weight: 600;
  background-color: #ffffff;
  color: #db011c !important;
  border: none;
}
.btn:hover {
  background-color: #f0f0f0;
}

@media (min-width: 768px) {
  h1 {
    font-size: 2rem;
  }

  .btn {
    min-height: 68px;
    font-size: 1.2rem;
  }
}
</style>
